import { IUser } from "@shared/mirage/core/contracts/IUser";
import { UserPermission } from "@shared/mirage/core/contracts/User";
import { IUserTablePreferences } from "@shared/mirage/services/IUserPreferencesService";
import { atom } from "recoil";

export const userState = atom({
    key: "userState",
    default: {} as UserStore,
});

export interface UserStore extends Partial<IUser> {
    id: number;
    permissions?: UserPermission[];
    expiryDate?: Date;
    sessionTimeoutBuffer?: number;
    subModules?: string[];
    superSetUrl?: string;
}

export const userPreferencesState = atom({
    key: "userPreferencesState",
    default: {} as UserPreferencesStore,
});

export interface UserPreferencesStore {
    entityTables: Record<string, IUserTablePreferences>;
}
